import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiArrowRight } = FiIcons;

export default function ProductShowcase() {
  const benefits = [
    "Whole Food Nutrition from Human Food Chain Ingredients",
    "Cellular Level Support for Energy and Vitality",
    "Non-GMO and Scientifically Validated Formulas",
    "60+ Year Legacy of Excellence and Integrity"
  ];

  return (
    <section id="products" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-0 rounded-[3rem] overflow-hidden shadow-2xl border border-slate-100">
          <div className="p-12 lg:p-20 bg-white flex flex-col justify-center">
            <span className="section-heading-label">The Foundation</span>
            <h3 className="section-heading-title">
              Nutrition Based in Nature, <br /> 
              <span className="text-[#005b2d]">Backed by Science.</span>
            </h3>
            <p className="text-lg text-slate-600 mb-10 leading-relaxed max-w-lg">
              To heal your spirit, you must first nourish your temple. NeoLife provides the highest quality whole-food supplements to support your physical restoration.
            </p>
            
            <ul className="space-y-5 mb-12">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex items-start gap-4 text-[#5E3A21] font-medium">
                  <div className="mt-1 bg-green-50 rounded-full p-1 opacity-100">
                    <SafeIcon icon={FiCheckCircle} className="text-[#005b2d] text-lg flex-shrink-0" />
                  </div>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <a 
              href="https://beta.neolife.com/peteandrosemary/en-US"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-neolife-primary w-fit group"
            >
              Explore Products
              <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
          
          <div className="relative min-h-[500px] bg-slate-100">
            <video 
              src="/media/showcase.mov"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover"
            />
            {/* Subtle vignette for depth without masking colors */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
}